import { useQuery } from 'glimmer-apollo'
import { parse } from 'graphql'

export interface AccountResponse {
  account: Account
}

export async function fetchAccount(context: Object): Promise<any> {
  const accountQuery = useQuery<AccountResponse>(context, () => [
    query,
    {
      onError: (error) => {
        throw new Error(`Failed to fetch account. ${error.message}`, { cause: error })
      }
    }
  ])

  return accountQuery.refetch()
}

const query = parse(`
  query Account {
    account {
      __typename
      ... on Account {
        availabilityBrandingConfig {
          headerLogoUrl
          headerStyle
          headerText
          theme
        }
        defaultPaymentProcessor {
          type
          ... on PaymentProcessorBraintree {
            tokenizationKey
          }
          ... on PaymentProcessorStripeConnect {
            publishableKey
            stripeConnectAccountId: accountId
          }
          ... on PaymentProcessorStripeIntents {
            publishableKey
            accountId
          }
          ... on PaymentProcessorStripeCustomConnect {
            publishableKey
            accountId
          }
          ... on PaymentProcessorStripe {
            publishableKey
          }
          ... on PaymentProcessorPaypal {
            paypalAccountId: accountId
            publishableKey
          }
        }
        enabledFeatureFlags
        name
      }
    }
  }
`)
